// source: message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proto.MessageIds', null, global);
/**
 * @enum {number}
 */
proto.proto.MessageIds = {
  MSG_DEFINE_NONE: 0,
  MSG_DEFINE_RESULT: 102,
  MSG_TRANS_MESSAGE: 1101,
  MSG_CHAT_REQUEST: 2001,
  MSG_CHAT_RESPONSE: 2002,
  MSG_CHAT_SYNCGATE: 2003,
  MSG_CHANNEL_CREATNOTIFY: 2004,
  MSG_CHANNEL_CLOSENOTIFY: 2005,
  MSG_CHANNEL_JOINREQUEST: 2006,
  MSG_CHANNEL_JOINRESPONSE: 2007,
  MSG_CHANNEL_SYNCUCTRLREQ: 2010,
  MSG_CHANNEL_SYNCUCTRLRSP: 2011,
  MSG_CHANNEL_SYNCCCTRLREQ: 2012,
  MSG_CHANNEL_SYNCCCTRLRSP: 2013,
  MSG_DIALOG_REQUEST: 2014,
  MSG_DIALOG_RESPONSE: 2015,
  MSG_DIALOG_RELAYREQUEST: 2016,
  MSG_DIALOG_RELAYRESPONSE: 2017,
  MSG_CHANNEL_CLOSEREQUEST: 2018,
  MSG_CHANNEL_CLOSERESPONSE: 2019,
  MSG_CHANNEL_USERNOTIFY: 2020,
  MSG_CHANNEL_STALKREQUEST: 2021,
  MSG_CHANNEL_STALKRESPONSE: 2022,
  MSG_CHANNEL_INVITEREQUEST: 2024,
  MSG_CHANNEL_INVITERESPONSE: 2025,
  MSG_CHANNEL_REPULSEREQUEST: 2026,
  MSG_CHANNEL_REPULSERESPONSE: 2027,
  MSG_CHANNEL_CHANNELCHANGENOTIFY: 2028,
  MSG_CHANNEL_CHANNELINFOREQ: 2029,
  MSG_CHANNEL_CHANNELINFORSP: 2030,
  MSG_CHANNEL_CHANNELMSGSENDREQ: 5003,
  MSG_CHANNEL_CHANNELMSGSENDRSP: 2032,
  MSG_CHANNEL_CHANNELMSGRELAYNTY: 5004,
  MSG_GATE_TRANSREQUEST: 2101,
  MSG_GATE_SETAIMSRV: 2102,
  MSG_GATE_TICKREQ: 2103,
  MSG_GATE_TICKRSP: 2104,
  MSG_GATE_C2CBUFFERREQ: 2105,
  MSG_GATE_C2CBUFFERNOTIFY: 2106,
  MSG_GATE_C2CBUFFERSDREQ: 2107,
  MSG_GATE_SETAIMRSP: 2108,
  MSG_GATE_OFFGATEREQ: 2109,
  MSG_GATE_C2CBUFFERRSP: 2110,
  MSG_GATE_C2CBUFFERRECIPT: 2111,
  MSG_USER_STATEREQ: 2201,
  MSG_USER_STATERSP: 2202,
  MSG_TICK_REQUEST: 2203,
  MSG_TICK_RESPONSE: 2204,
  MSG_USER_ONLINEREQ: 2205,
  MSG_USER_RELOADREQ: 2206,
  MSG_USER_OFFLINEREQ: 2207,
  MSG_USER_GETUSERTALKINGCHANNELREQ: 2208,
  MSG_USER_GETUSERTALKINGCHANNELRSP: 2209,
  MSG_USER_USERLASTSTATUSNOTIFY: 2210,
  MSG_USER_ONLINERSP: 2211,
  MSG_CONFIG_REQ: 2301,
  MSG_CONFIG_RSP: 2302,
  MSG_CSYNC_NOTIFY: 2401,
  MSG_CSYNC_SYNCMARKNOTIFY: 2402,
  MSG_CSYNC_FREEZENOTIFY: 2403,
  MSG_CSYNC_DRAWDATANOTIFY: 2404,
  MSG_CSYNC_CAMERAZOOMNOTIFY: 2405,
  MSG_CSYNC_CAMERAFOCUSNOTIFY: 2406,
  MSG_CSYNC_DRAWREVOKENOTIFY: 2407,
  MSG_CSYNC_DRAWCLEARNOTIFY: 2408,
  MSG_CSYNC_WHITEBOARDIMAGENOTIFY: 2409,
  MSG_CSYNC_DRAWDATAWEBNOTIFY: 2410,
  MSG_CSYNC_WEBDATA: 2411,
  MSG_CSYNC_REMOTECONTROL: 2412,
  MSG_CSYNC_TRACKDATANOFITY: 2413,
  MSG_CHANNELMARKDATA_FREEZEDATA: 2414,
  MSG_CHANNELMARKDATA_MARKDATA: 2415,
  MSG_CSYNC_PORTALDATANOTIFY: 2417,
  MSG_CSYNC_DRAWDATAARRAYNOTIFY: 2418,
  MSG_RECORD_CREATEREQUEST: 2501,
  MSG_RECORD_CREATERESPONSE: 2502,
  MSG_RECORD_REMOVEREQUEST: 2503,
  MSG_RECORD_REMOVERESPONSE: 2504,
  MSG_RECORD_QUERYREQUEST: 2505,
  MSG_RECORD_QUERYRESPONSE: 2506,
  MSG_GRECORD_URLREQUEST: 2507,
  MSG_GRECORD_URLRESPONSE: 2508,
  MSG_GRECORD_EVENTREQUEST: 2509,
  MSG_GRECORD_EVENTRESPONSE: 2510,
  MSG_CALLLOG_REQUEST: 2511,
  MSG_CALLLOG_RESPONSE: 2512,
  MSG_PUSH_TOKENREPORT: 2601,
  MSG_PUSH_PUSHREQUEST: 2602,
  MSG_PUSH_TOKENREPEAL: 2603,
  MSG_PUSH_DEVICEREPEAL: 2604,
  MSG_PUSH_CLIENTLOGNTY: 2605,
  MSG_PUSH_STARTLIVINGPUSHNOTIFY: 2606,
  MSG_FOUNDATION_TEXT: 2701,
  MSG_FOUNDATION_IMAGE: 2702,
  MSG_DEFINE_ERROR: 3001,
  MSG_IM_KEEPLIVEREQ: 4001,
  MSG_IM_KEEPLIVERSP: 4002,
  MSG_IM_ACCESSIMREQ: 4003,
  MSG_IM_ACCESSIMRSP: 4004,
  MSG_IM_EXITIMNTY: 4005,
  MSG_IM_GROUPCHECKINREQ: 4006,
  MSG_IM_GROUPCHECKINRSP: 4007,
  MSG_IM_GROUPRECENTOFFLINEMSGSNTY: 4008,
  MSG_IM_GROUPMSGSENDREQ: 4009,
  MSG_IM_GROUPMSGSENDRSP: 4010,
  MSG_IM_GROUPMSGRELAYNTY: 4011,
  MSG_IM_GROUPMSGRELAYRECEIPT: 4012,
  MSG_IM_GROUPMSGRECEIPTACK: 4013,
  MSG_IM_GROUPSTATUSCHANGENTY: 4014,
  MSG_IM_USERSESSIONCTRLNTY: 4015,
  MSG_IM_USERSTATUSCHANGENTY: 4016,
  MSG_IM_GETUSERSTATUSREQ: 4017,
  MSG_IM_GETUSERSTATUSRSP: 4018,
  MSG_IM_SYNCGROUPMSGTODBNTY: 4019,
  MSG_IM_SYNCGROUPMSGRECEIPTTODBNTY: 4020,
  MSG_IM_GETGROUPMSGSFROMDBREQ: 4021,
  MSG_IM_GETGROUPMSGSFROMDBRSP: 4022,
  MSG_IM_LIVESTATUSREPORTREQ: 4023,
  MSG_IM_LIVESTATUSREPORTRSP: 4024,
  MSG_HISRTC_CREATECHANNELEVENTNTY: 5001,
  MSG_HISRTC_DELETECHANNELEVENTNTY: 5002,
  MSG_HISRTC_JOINCHANNELEVENTNTY: 5009,
  MSG_HISRTC_LEAVECHANNELEVENTNTY: 5010,
  MSG_HISRTC_DEVICECTRLEVENTNTY: 5005,
  MSG_HISRTC_WHITEBOARDEVENTNTY: 5006,
  MSG_HISRTC_MARKNOTIFYEVENTNTY: 5007,
  MSG_HISRTC_GRAFFITIEVENTNTY: 5008
};

goog.object.extend(exports, proto.proto);
